<div class="ibox">
    <div class="ibox-content">
        <form #webhookSubscriptionForm="ngForm" *ngIf="webhookSubscription">
            <div class="globalConfiguration">
                <div class="row">
                    <div class="col-md-12">
                        <h1 [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.title'}]"></h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="control-label" for="email-notify" [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.settings.email-notify'}]"></label>
                            <input class="form-control input-lg"
                                   name="email-notify"
                                   id="email-notify"
                                   #emailInput="ngModel"
                                   type="email"
                                   [disabled]="formProcessingBlocked"
                                   email
                                   [(ngModel)]="webhookSubscription.email">
                            <label class="error" *ngIf="emailInput.dirty && emailInput.touched && emailInput.errors && emailInput.errors.email"
                                   [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.settings.email-error'}]">
                            </label>
                            <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.settings.email-notify-mention'}]"></small>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="control-label" for="notify" [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.settings.notify'}]"></label>
                            <div class="row switchContainer">
                                <div class="col-md-12">
                                    <app-switcher id="notify"
                                                  name="notify-active"
                                                  [disabled]="formProcessingBlocked"
                                                  [(ngModel)]="webhookSubscription.active"
                                                  [labelKey]="'webhooks-events.subscriptions.settings.notify-' + webhookSubscription.active">
                                    </app-switcher>
                                </div>
                            </div>
                            <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.settings.notify-mention'}]"></small>
                        </div>
                    </div>
                    <div class="col-md-4"></div>
                </div>
            </div>

            <hr>

            <div class="row">
                <div class="col-md-10">
                    <h1 [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.events.title'}]"></h1>
                </div>
                <div class="col-md-2 text-right">
                    <button class="btn btn-primary btn-md pull-right"
                            type="button"
                            (click)="openAddEvent(addEventModal)"
                            [disabled]="allEventTypes.length === webhookSubscription.subscriptionEvents.length || formProcessingBlocked">
                        <span class="fa fa-plus"></span>
                        <span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.events.add-event'}]"></span>
                    </button>
                </div>
            </div>

            <div class="row deliveryEventItem" *ngFor="let webhookSubscriptionEvent of webhookSubscription.subscriptionEvents">
                <div class="col-sm-2">
                    <h3 [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.events.type.' + webhookSubscriptionEvent.eventType}]"></h3>
                </div>
                <div class="col-sm-1 text-right deliveryEventItem-info">
                    <a (click)="displayDocumentationFor(webhookSubscriptionEvent)"><i class="fa fa-question-circle"></i></a>
                </div>
                <div class="col-sm-1 text-right deliveryEventItem-httpVerb">
                    <h3>{{ webhookSubscriptionEvent.httpVerbCallback }}</h3>
                </div>
                <div class="col-sm-5 deliveryEventItem-id">
                    <div class="form-group">
                        <input class="form-control input-lg"
                               [name]="webhookSubscriptionEvent.eventType + 'callback'"
                               [ngModel]="webhookSubscriptionEvent.urlCallback"
                               disabled
                               type="text">
                    </div>
                </div>
                <div class="col-sm-4 deliveryEventItem-action">
                    <button class="btn btn-primary btn-outline btn-lg"
                            type="button"
                            (click)="sendATry(webhookSubscriptionEvent)">
                        <span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.events.give-try'}]"></span>
                    </button>
                    <button class="btn btn-primary btn-outline btn-lg pull-right"
                            type="button"
                            [disabled]="formProcessingBlocked"
                            (click)="removeWebhookEventSubscription(webhookSubscriptionEvent)">
                        <span class="fa fa-times"></span>
                    </button>
                    <button class="btn btn-primary btn-outline btn-lg pull-right m-r-sm"
                            type="button"
                            [disabled]="formProcessingBlocked"
                            (click)="openEditEvent(editEventModal, webhookSubscriptionEvent)">
                        <span class="fa fa-pencil-alt"></span>
                    </button>
                </div>
            </div>

            <hr>

            <div class="form-buttons text-right">
                <button type="submit" class="btn btn-primary btn-lg"
                        (click)="saveSubscription()"
                        [disabled]="webhookSubscriptionForm.invalid || webhookSubscriptionForm.pristine || formProcessingBlocked">
                    <span class="fa fa-save space-right-5"></span>
                    <span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.save'}]"></span>
                </button>
            </div>
        </form>
    </div>
</div>

<ng-template #addEventModal>
    <form #addEventForm="ngForm" novalidate class="row">
        <div class="col-sm-24">
            <div class="form-group">
                <label class="control-label" for="select-event-type"
                       [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.events.select-event'}]">
                </label>
                <select id="select-event-type"
                        name="select-event-type"
                        [(ngModel)]="newSubscriptionEvent.eventType"
                        required
                        class="form-control input-lg">
                    <option *ngFor="let eventType of allowedEventTypes" [value]="eventType">
                        <span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.events.type.' + eventType}]"></span>
                    </option>
                </select>
            </div>
        </div>
        <div class="col-sm-24">
            <div class="form-group">
                <label class="control-label" for="new-event-callback-url"
                       [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.events.url'}]">
                </label>
                <div class="row">
                    <div class="col-sm-2">
                        <select id="select-http-verb"
                                name="select-http-verb"
                                [(ngModel)]="newSubscriptionEvent.httpVerbCallback"
                                required
                                class="form-control input-lg">
                            <option *ngFor="let httpVerb of allWebhookHttpVerbs" [value]="httpVerb">
                                {{ httpVerb }}
                            </option>
                        </select>
                    </div>

                    <div class="col-sm-10">
                        <input class="form-control input-lg"
                               id="new-event-callback-url"
                               name="event-callback-url"
                               required
                               [(ngModel)]="newSubscriptionEvent.urlCallback"
                               type="text">
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-template>


<ng-template #editEventModal>
    <form #editEventForm="ngForm" novalidate class="row">
        <div class="col-sm-24">
            <div class="form-group">
                <label class="control-label" for="edit-event-callback-url"
                       [i18n]="[{target: 'innerHTML', key: 'webhooks-events.subscriptions.events.url'}]">
                </label>
                <div class="row">
                    <div class="col-sm-2">
                        <select id="edit-select-http-verb"
                                name="edit-select-http-verb"
                                [(ngModel)]="editSubscriptionEventUrlCallbackVerb"
                                required
                                class="form-control input-lg">
                            <option *ngFor="let httpVerb of allWebhookHttpVerbs" [value]="httpVerb">
                                {{ httpVerb }}
                            </option>
                        </select>
                    </div>

                    <div class="col-sm-10">
                        <input class="form-control input-lg"
                               id="edit-event-callback-url"
                               name="event-callback-url"
                               required
                               [(ngModel)]="editSubscriptionEventUrlCallback"
                               type="text">
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-template>

